import React from 'react'

import OrderSearchForm from '@abra/panels/OrderSearchForm'

import { Collapse, Box } from '@mui/material'

const SearchForm = ({ toggle, setToggle }) => (
  <Collapse in={!!toggle}>
    <Box sx={{ width: '100%', mt: 1, p: 1, boxShadow: 6, borderRadius: 1 }}>
      <OrderSearchForm mode='order' setToggle={setToggle} toggle={toggle} />
    </Box>
  </Collapse>
)

export default React.memo(SearchForm)
